<template id="AccountTable">
	<section>
		<!-- 工具條 -->
		<el-col :span="24" class="tool-bar">
			<el-cascader :span="24"  placeholder="" class="menu-select"
							v-show="$store.state.isSystemAdminMode"
							v-model="$store.state.accountList.selectedDepId"
							:show-all-levels="false"
    						:options="actualDepsOptions"
							@change="handleActualDepSelect">
			</el-cascader>
			<el-button v-show="sels.length === 0" class="base-btn add-btn" @click="addDialog = true">建新帳號
				<img src="../../assets/icon/ic_add.png" alt="A" class="base-icon">
			</el-button>
			<el-button v-show="(sels.length === 0)&&showEditBtn" class="base-btn edit-btn" @click="editDialog = true">批次修改帳號
				<img src="../../assets/icon/ic_edit_white.png" alt="E" class="base-icon">
			</el-button>
			<div v-show="sels.length > 0">
				<el-button class="general-btn" @click="stopAccounts()">停權</el-button>
				<el-button class="general-btn" @click="openAccounts()">開通</el-button>
			</div>
		</el-col>
		<!-- 分頁 -->
		<el-col :span="24" class="page-bar">
			<div class="total-results"> {{totalResult}} </div>
			<el-pagination v-if="accounts.length > 0" 
										 layout="prev, pager, next" 
										 prev-text="prev" 
										 next-text="next" 
										 :current-page="$store.state.accountList.currentPage" 
										 @current-change="handleCurrentChange" 
										 :page-size="$store.state.accountList.pageCount" 
										 :total="total" 
										 style="float:right;">
			</el-pagination>
		</el-col>

		<!--搜尋狀態且無結果-->
		<div v-if="accounts.length === 0 && $store.state.accountList.status && !listLoading" class="search-no-item">
			<img src="../../assets/icon/ic_nofound.png" alt="N" class="nofound-icon">
			<div class="title-no-item">抱歉，我們找不到您搜尋的帳號或姓名</div>
			<div class="vice-title-no-item">請嘗試不同的搜尋詞</div>
		</div>

		<!--列表-->
		<el-table v-else :data="accounts" 
		          v-loading="listLoading"
							ref="multipleTable" 
							empty-text="暫無結果"
							@select="selectRow" 
							@selection-change="selsChange" 
							@row-click="rowClick" 
							@sort-change="sortChange"
							style="min-width: 100%;">
			<el-table-column min-width="3%" type="selection">
			</el-table-column>
			<el-table-column min-width="10%" prop="name" label="帳號" sortable="custom">
			</el-table-column>
			<el-table-column min-width="10%" prop="displayname" label="姓名" sortable="custom"> 
			</el-table-column>
			<el-table-column min-width="25%" prop="email" label="信箱" sortable="custom"> 
			</el-table-column>
			<el-table-column min-width="15%" prop="actualDepName" label="部門" sortable="custom">
			</el-table-column>
			<el-table-column min-width="9%" prop="level" label="權限" :formatter="formatLevel" sortable="custom">
			</el-table-column>
			<el-table-column min-width="9%" prop="ismanager" label="身份" :formatter="formatManager" sortable="custom">
			</el-table-column>
			<el-table-column min-width="10%" prop="status" label="狀態" sortable="custom">
				<template slot-scope="scope">	
					<div v-if="formatStatus(scope.row) === 1">
						<div class="open-circle-status"></div>
						<div class="open-status">開通</div>
					</div>
					<div v-else>
						<div class="close-circle-status"></div>
						<div class="close-status">停權</div>
					</div>
				</template>
			</el-table-column>
			<el-table-column min-width="11%" label=""> 
				<template slot-scope="scope">	
					<div v-if="scope.row.included===0">
						<span v-if="scope.row.not_included_date === null">
							不列入統計
						</span>
						<span v-else>
							不列入統計至<br/>
							{{ scope.row.not_included_date}}
						</span>
					</div>
				</template>
			</el-table-column>
			<!--
			<el-table-column width="150">
				<template slot-scope="scope">
					<el-button type="text" icon="el-icon-edit" size="medium" @click="handleEdit(scope.$index, scope.row)">編輯</el-button>
					<el-button type="text" icon="el-icon-delete" size="medium" @click="handleDel(scope.$index, scope.row)">删除</el-button>
				</template>
			</el-table-column>
			-->	
		</el-table>

		<hint v-show="hint.display && this.$store.state.hintStatus.table" :message="hint.message" @close="closeHint"></hint>
		<account-import ref="accountImport" @showHint="showHint"  @getAccounts="getAccounts"
      		:actualDepsOptions="actualDepsOptionsForImport" 
			:importCsvName="importCsvName" :importCsvArray="importCsvArray">
		</account-import>
		<el-dialog class="account-add-dialog" 
			id="addDialog"
			title="建新帳號" 
			:visible.sync="addDialog">
			<div class="dialog-row">
				<img src="../../assets/icon/ic_new_account.png" >
				<span style="margin-left:15px">建立一筆新帳號</span>
				<el-button class="general-btn" @click="addAccount">馬上建立</el-button>
				
			</div>
			<div class="divider"></div>
			<div class="dialog-row">
				<img src="../../assets/icon/ic_new_accounts.png" >
				<span style="margin-left:15px">一次匯入多筆新帳號</span>
				<el-button class="general-btn" @click="chooseCSV">選擇檔案</el-button>
			</div>
			<div class="csv-hint">
				僅接受 csv 格式的檔案
			</div>
			<span slot="footer" class="dialog-footer" >
				<a class="import-sample" href="./static/Import_User_Sample.csv" download="Import_User_Sample.csv">
					不知道格式如何填寫 ? 下載匯入帳號 csv 文件範本
            	</a>
			</span>
			<input v-show="false" type="file" name="File Upload" ref="importCsv" accept=".csv" v-on:change="handleFilesUpload()"/>
		</el-dialog>
		<account-update ref="accountUpdate" @showHint="showHint" @getAccounts="getAccounts"
		 	:actualDepsOptions="actualDepsOptionsForImport" 
		 	:updateCsvArray="updateCsvArray">
		</account-update>
		<el-dialog class="account-edit-dialog" 
			id="editDialog"
			title="批次修改帳號" 
			:visible.sync="editDialog">
			<div class="content-text">
				下載現有帳號的csv檔案，請修改後再將檔案上傳至此
			</div>
			<div class="button-row">
				<el-button class="general-btn" :loading="csvLoading" @click="generateCSV">下載檔案</el-button>
				<el-button class="general-btn" @click="chooseUpdateCSV"> 上傳檔案</el-button>
			</div>
			<downloadCsv ref="downloadCsv" :data = "csvData" 
			name = "data.csv" :labels="csvLabels" style="display: none;"></downloadCsv>
			<input v-show="false" type="file" name="Update Upload" ref="updateCsv" accept=".csv" v-on:change="handleUpdateUpload()"/>
		</el-dialog>
	</section>
</template>

<script>
import API from '../../api/api';
import util from '@/common/js/util';
import { DepartmentModel } from '@/common/js/data';
import AccountUtil from '@/common/js/account';
import AccountImport from "./AccountImport";
import AccountUpdate from "./AccountUpdate";
	export default {
		name: 'account',
		components: {
			AccountImport,
			AccountUpdate,
		},
		data() {
			return {
				showEditBtn: false,
				addDialog: false,
				editDialog: false,
				csvLoading: false,
				csvData:[],
				csvLabels: {
					id: "原工號",
					displayname: "姓名",
					new_id: "新工號",
					email: "e-Mail",
					level: "Level",
				},
				importCsvName: '',
				importCsvArray: [],
				updateCsvArray: [],
				//帳號
				accounts: [],
				//帳號列表顯示結果字串
				totalResult: '',
				total: 0,
				//loading
				listLoading: false,
				//部門filter
				actualDepsOptions: [],
				actualDepsOptionsForImport: [],
				//跳出hint
				hint: {
					message: '',
					display: false,
				},
				sels: [],//列表选中列
			}
		},
		created() {
			this.$store.state.accountList.keyword = decodeURI(location.hash.split('/key=')[1]);
			this.$store.state.nowStatus = 7;
			if(this.$store.state.accountList.status === 0) {
				this.$store.state.accountList.selectedDepId = [0];
				this.$store.state.accountList.offset = 0;
				this.$store.state.accountList.order = null;
				this.$store.state.accountList.by = null;
				this.$store.state.accountList.currentPage = 1;
			}
			this.listLoading = true;
			this.initial();
			this.initActualDepsOptions();
		},
		beforeRouteUpdate: function (to, from, next) {
			this.$store.state.accountList.keyword = to.path.split('/key=')[1];
			this.$store.state.accountList.offset = 0;
			this.$store.state.accountList.currentPage = 1;
			next();
			this.getAccounts();
		},
		methods: {
			initial: function() {
				//取得使用者資訊
				API.getUser().then((result) => {
					if(result.status) {
						redirectLogin(result.data);
						if(!JSON.parse(result.request.response).error_msg) {
							this.showHint('取得使用者資訊錯誤!');
						} else {
							this.showHint(JSON.parse(result.request.response).error_msg);
						}
					} else {
						//update username
						this.$store.state.userName = result.name;
						API.accountInfo(this.$store.state.userName).then((result) => {
							if(result.status !== 0 && result.status !== 1) {
								redirectLogin(result.data);							
							} else {
								this.$store.state.userDepId = result.depId;
								this.$store.state.userActualDepId = result.actual_depid;
								if(result.isManager === 2) {
									this.$store.state.isSystemAdminMode = true;
									this.$store.state.isBackendMode = true;
								} else if(result.isManager === 1) {
									this.$store.state.isSystemAdminMode = false;
									this.$store.state.isBackendMode = true;
								} else {
									this.$store.state.isSystemAdminMode = false;
									this.$store.state.isBackendMode = false;	
								}

								//代表不是編輯帳號就離開
								if(!this.$store.state.isBackendMode) {
									this.$router.push({ path: '/table' });
									return;
								}

								//this.$store.accountList.status = 0;	
							}
						});	
					}
				});
			},
			/**
			  * getAccounts 取得帳號列表
			  * @return none
			  */    
			getAccounts() {
				this.accounts.length = 0;
				this.listLoading = true;
				let actual_depid = (this.$store.state.accountList.selectedDepId.length > 1) ? 
				this.$store.state.accountList.selectedDepId[1] : null;
				this.showEditBtn = actual_depid ? true : false;
				API.getAccountList(actual_depid, null, 
													 this.$store.state.accountList.pageCount, 
													 this.$store.state.accountList.offset, 
													 this.$store.state.accountList.keyword, 
													 this.$store.state.accountList.by, 
													 this.$store.state.accountList.order).then((response) => {
					if(response.status) {
						redirectLogin(response.data);
						if(!JSON.parse(response.request.response).error_msg) {
							this.showHint('取得會員帳號清單錯誤!');
						} else {
							this.showHint(JSON.parse(response.request.response).error_msg);	
						}
					} else {
						for(let i = 0 ; i < this.$store.state.accountList.pageCount ; i++) {
							if(response.result[i]) {
								let obj = {};
								obj.name = response.result[i].user.username;
								obj.displayName = response.result[i].user.displayname;
								obj.displayname = response.result[i].user.displayname;
								obj.email = response.result[i].user.email;
								obj.dep = response.result[i].dep.id;
								obj.depId = response.result[i].dep.id;
								obj.actual_depid = response.result[i].actual_depid;
								obj.actualDepName = response.result[i].actual_dep ? response.result[i].actual_dep.name : "";
								obj.level = response.result[i].level;
								obj.isManager = response.result[i].isManager;
								obj.ismanager = response.result[i].isManager;
								obj.status = response.result[i].status;
								obj.included = response.result[i].included;
								if (response.result[i].not_included_date) {
									let time = response.result[i].not_included_date * 1000;
									obj.not_included_date = util.formatDate.format(new Date(time), 'yyyy-MM-dd');
								} else {
									obj.not_included_date = null;
								}
								this.accounts.push(obj);
							}
						}

						this.total = response.total;
						
						//帳號列表顯示結果字串
						if(this.accounts.length === 0) {
							this.totalResult = ' 共 ' + this.total + ' 筆帳號';
						} else {
							this.totalResult = this.$store.state.accountList.pageCount * (this.$store.state.accountList.currentPage - 1) + 
																1 + ' - ' + (this.$store.state.accountList.pageCount * (this.$store.state.accountList.currentPage - 1) + 
																response.result.length) + ' 筆，' + ' 共 ' + this.total + ' 筆帳號';
						}
					}
					//close loading
					this.listLoading = false;
				});
			},
			async initActualDepsOptions() {
				let departmentModel = new DepartmentModel();
				this.actualDepsOptionsForImport = await departmentModel.getActualDepsOptions();
				this.actualDepsOptions = JSON.parse(JSON.stringify(this.actualDepsOptionsForImport));
				let defaultAll = { 
					'value': 0,
					'label': '全部'
				};
				this.actualDepsOptions.unshift(defaultAll);
				this.getAccounts();
			},
			/**
			  * formatStatus 會員狀態轉換
			  * @param  {object}  row    - row
			  * @param  {object}  column - column
			  * @return {string}  status - 會員狀態
    		  */
			formatStatus: function (row, column) {
				return row.status;
			},
			/**
			  * formatLevel 會員等級轉換
			  * @param  {object}  row    - row
			  * @param  {object}  column - column
			  * @return {string}  level  - 會員等級
    		  */
			formatLevel: function (row, column) {
				return 'Level ' + row.level;
			},
			/**
			  * formatManager 管理員轉換
			  * @param  {object}  row       - row
			  * @param  {object}  column    - column
			  * @return {string}  isMabager - 管理者
    		  */
			formatManager: function (row, column) {
				if(row.isManager === 1) {
					return '部門管理員';
				} else if(row.isManager === 2) {
					return '系統管理員';	
				} else {
					return '一般';	
				}
			},
			/**
			  * handleCurrentChange 列表頁數切換
			  * @param  {number}  val - 切換到的頁數
			  * @return none
    		  */
			handleCurrentChange(val) {
				//update currentPage
				this.$store.state.accountList.currentPage = val;
				//update offset
				this.$store.state.accountList.offset = this.$store.state.accountList.pageCount * (this.$store.state.accountList.currentPage - 1);
				//取得資源列表
				this.getAccounts();
			},
			//删除
			/*
			handleDel: function (index, row) {
				this.$confirm('您確定要刪除帳號' + ' "' + row.name + '" 嗎? 這將會從 E-learning 會員資料中移除' + ' "' + row.displayname + '"', 
				              '刪除會員帳號', {
					confirmButtonText: '確定',
					cancelButtonText: '取消',
					html: true 
				}).then(() => {
					this.listLoading = true;
					API.deleteAccount(row.name).then((response) => {
						if(response.status) {
							redirectLogin(response.data);
							if(!JSON.parse(response.request.response).error_msg) {
								this.showHint('刪除會員帳號錯誤!');
							} else {
								this.showHint(JSON.parse(response.request.response).error_msg);	
							}
						} else {
							this.$store.accountList.status = 0;
							this.getAccounts();
						}
					});
				}).catch(() => {

				});
			},
			*/
			//編輯
			handleEdit: function (index, row) {
				this.$router.push({ path: '/editAccount/' + row.name});
			},
			selectRow: function (selection, row) {
				if (row.actual_depid === 0) {
					this.$refs.multipleTable.toggleRowSelection(row, false);
					this.$alert('請先設定部門，才能開通帳號．', '提醒', {
						confirmButtonText: '確定',
					}).then();
				}
			},
			rowClick: function(row, event) {
				if(event.target.nodeName === 'SPAN' || event.target.nodeName === 'INPUT' || this.sels.length > 0) {
					return;
				}
				if(row.isManager === 2 && !this.$store.state.isSystemAdminMode) {
					this.$alert('部門管理員沒有編輯系統管理員的權限', '警告', {
						confirmButtonText: '確定',
					}).then(() => {
						
					});
					return;
				}
				this.$router.push({ path: '/editAccount/' + row.name});	
			},
			selsChange: function (sels) {
				this.sels = sels;
			},
			/**
			  * sortChange 排序切換
			  * @param  {column}  object - columnobject
			  * @return none
    		*/
			sortChange: function(column, prop, order) {	
				//update sort order
				if(column.order === 'descending') {
					this.$store.state.accountList.order = 'desc';	
				} else if(column.order  === 'ascending') {
					this.$store.state.accountList.order = 'asc';	
				} else {
					this.$store.state.accountList.order = null;		
				}

				//update sort by
				this.$store.state.accountList.by = (column.prop == "actualDepName") ? "actual_dep" : column.prop;
				//取得資源列表
				this.getAccounts();
			},
			openAccounts: function() {
				let that = this;
				that.$confirm('確認開通所選取的會員？', '提示', {
					confirmButtonText: '確定',
          			cancelButtonText: '取消',
				}).then(() => {
					that.listLoading = true;
					let promises = [];
					let error = [];
					for(let i = 0 ; i < that.sels.length ; i++) {
						promises.push(new Promise((resolve, reject) => {
							let obj = that.sels[i];
							obj.status = 1;
							API.editAccount(obj).then((response) => {
								if(response.status) {
									error.push(obj.name);
									resolve(response);
								} else {
									resolve(response);	
								}
							});
						}));
					}

					Promise.all(promises).then((res) => {	
						if(error.length > 0) {
							let hint = '';
							for(let i = 0 ; i < error.length ; i++) {
								hint += ' [' + error[i] + ']  '
							}
							if(promises.length === error.length) {
								that.showHint(hint + " 開通失敗");
							} else {
								that.showHint("開通完成， " + hint + " 開通失敗");
							}
						} else {
							that.showHint('開通完成');
						}
						that.getAccounts();
					});		
				}).catch(() => {

				});
			},
			stopAccounts: function() {
				let that = this;
				that.$confirm('確認停權所選取的會員？', '提示', {
					confirmButtonText: '確定',
          			cancelButtonText: '取消',
				}).then(() => {
					that.listLoading = true;
					let promises = [];
					let error = [];
					for(let i = 0 ; i < that.sels.length ; i++) {
						promises.push(new Promise((resolve, reject) => {
							let obj = that.sels[i];
							obj.status = 0;
							API.editAccount(obj).then((response) => {
								if(response.status) {
									error.push(obj.name);
									resolve(response);
								} else {
									resolve(response);	
								}
							});
						}));
					}

					Promise.all(promises).then((res) => {	
						if(error.length > 0) {
							let hint = '';
							for(let i = 0 ; i < error.length ; i++) {
								hint += ' [' + error[i] + ']  '
							}
							if(promises.length === error.length) {
								that.showHint(hint + " 停權失敗");
							} else {
								that.showHint("停權完成， " + hint + " 停權失敗");
							}
						} else {
							that.showHint('停權完成');
						}
						that.getAccounts();
					});		
				}).catch(() => {

				});
			},
			handleActualDepSelect: function(key) {
				this.$store.state.accountList.offset = 0;	
				this.$store.state.accountList.currentPage = 1;
				this.getAccounts();
			},
			addAccount: function() {
				this.$router.push({ path: '/editAccount/'});
			},
			closeHint: function() {
				this.hint.display = false;
				this.$store.state.hintStatus.table = false;
				clearTimeout(this.timer);
			},
			showHint: function(message) {
				if(this.timer) {
					clearTimeout(this.timer);	
				}
				this.hint.display = true;
				this.hint.message = message;	
				this.$store.state.showHint = true;
				this.$store.state.hintStatus.table = true;
				this.timer = setTimeout(()=>{
					if(this.$store.state.showHint) {
						this.$store.state.showHint = false;
						this.$store.state.hintStatus.table = false;
        			}
        		}, this.$store.state.fadeOutTime);
			},
			chooseCSV() {
				this.$refs.importCsv.click();
			},
			async handleFilesUpload() {
				if(this.$refs.importCsv.files[0]) {
					let importCsvRef = this.$refs.importCsv.files[0];
					this.importCsvArray.splice(0);
					let selectedDepId = this.$store.state.isSystemAdminMode ? 
						this.$store.state.accountList.selectedDepId : [this.$store.state.userDepId, this.$store.state.userActualDepId]
					try {
						this.importCsvArray = await AccountUtil.importFileToArray(importCsvRef, selectedDepId);
						this.importCsvName = importCsvRef.name;
						this.$nextTick(() => {
							this.$refs.accountImport.startImport();
							this.addDialog = false;
						});
					} catch (rejectedValue) {
						this.showHint(rejectedValue);
					}	
				} else {
					this.showHint('選取檔案發生錯誤!');
				}
				this.$refs.importCsv.value = '';
			},
			async generateCSV() {
				this.csvLoading = true;
				this.csvData.splice(0);
				let selectedActualDepId = (this.$store.state.accountList.selectedDepId.length > 1) ? 
					this.$store.state.accountList.selectedDepId[1] : null;
				let actual_depid = this.$store.state.isSystemAdminMode ? 
					selectedActualDepId : this.$store.state.userActualDepId;
				API.getAccountList(actual_depid, null, 9999, null, this.$store.state.accountList.keyword,  null, null).then(
					(response) => {
						if(response.status) {
							if(!JSON.parse(response.request.response).error_msg) {
								this.showHint('取得會員帳號清單錯誤!');
							} else {
								this.showHint(JSON.parse(response.request.response).error_msg);	
							}
						} else {
							for(let i = 0 ; i < response.result.length ; i++) {
								if(response.result[i]) {
									let obj = {};
									obj.id = response.result[i].user.username;
									obj.displayname = response.result[i].user.displayname;
									obj.new_id = response.result[i].user.username;
									obj.email = response.result[i].user.email;
									obj.level = response.result[i].level;
									this.csvData.push(obj);
								}
							}
							this.$refs.downloadCsv.generate();
						}
						this.csvLoading = false;
					});
			},
			chooseUpdateCSV() {
				this.$refs.updateCsv.click();
			},
			async handleUpdateUpload() {
				if(this.$refs.updateCsv.files[0]) {
					let updateCsvRef = this.$refs.updateCsv.files[0];
					this.updateCsvArray.splice(0);
					let selectedDepId = this.$store.state.isSystemAdminMode ? 
						this.$store.state.accountList.selectedDepId : [this.$store.state.userDepId, this.$store.state.userActualDepId]
					try {
						this.updateCsvArray = await AccountUtil.importUpdatesToArray(updateCsvRef, selectedDepId);
						this.$nextTick(() => {
							this.$refs.accountUpdate.startUpdate();
							this.editDialog = false;
						});
					} catch (rejectedValue) {
						this.showHint(rejectedValue);
					}	
				} else {
					this.showHint('選取檔案發生錯誤!');
				}
				this.$refs.updateCsv.value = '';
			},
			
		},
		mounted() {

		}
	}

</script>

<style lang="scss">
	.el-table {
		cursor: pointer;
		color: #626874;
		font-size: 14px;
	}

	.el-table::before {
		height: 0px;
	}

	.el-icon-arrow-left::before {
		content : "❮";
		display: block;
	}

	.el-icon-arrow-right::before {
		content : "❯";
		display: block;
	}

	.el-icon-more:before {
		content : "⋯";
		display: block;	
	}

	.el-icon-d-arrow-left::before {
		content : "⟪";
		display: block;
	}

	.el-icon-d-arrow-right::before {
		content : "⟫";
		display: block;
	}

	.el-table__header-wrapper thead div {
		background-color: #fff;
	}
	.el-table th {
		background-color: #fff;	
	}

	.el-table--enable-row-hover .el-table__body tr input[type=checkbox] {
		background-color: #F0F7FF !important;
		border-top: 1px solid #2E90F4 !important;
		border-bottom: 1px solid #2E90F4 !important;
		color: #1C6BBC !important;	
		z-index: 2;
	}
	
	.el-table--enable-row-hover .el-table__body tr:hover td {
		background-color: #F0F7FF !important;
		border-top: 1px solid #2E90F4 !important;
		border-bottom: 1px solid #2E90F4 !important;
		color: #1C6BBC !important;
		z-index: 2;
	}

	.el-table--enable-row-hover .el-table__body tr:hover td:first-child {
		border-left: 1px solid #2E90F4 !important;
		z-index: 2;
	}

	.el-table--enable-row-hover .el-table__body tr:hover td:last-child {
		border-right: 1px solid #2E90F4 !important;
		z-index: 2;
	}

	.el-table .caret-wrapper {
		width: 32px;
    	height: 36px;
	}

	.el-table .sort-caret.ascending {
		border-bottom: 7px solid #97a8be;
	}

	.el-table .sort-caret.descending {
		border-top: 7px solid #97a8be;
	}

	.el-dialog--small {
		width: 40%;
	}

	.tool-bar {
		height: 54px;
		background: #FFFFFF;
		border-top: 1px solid #EEE;
		border-left: 1px solid #EEE;
		border-right: 1px solid #EEE;
		.delete-btn {
			float: right;
			display: block;
		}

		.base-btn {
			float: right;
			display: block;
			background: #2E90F4;
			border-radius: 2px;
			color: #fff;
			height: 36px;
			border: none;
			margin-top: 9px;
			margin-right: 20px;

			.base-icon {
				height: 14px;
				width: 14px;
				float: left;
			}
		}

		.add-btn {
			width: 108px;
		}

		.edit-btn {
			width: 136px;
		}
		.general-btn {
			float: right;
			display: block;
			background: #2E90F4;
			border-radius: 2px;
			color: #fff;
			font-size: 14px;
			height: 36px;
			border: none;
			margin-top: 9px;
			margin-right: 20px;
			white-space: normal;
			width: 92px;
		}	
		.general-btn:hover {
			background: #42A0FF;
			cursor: pointer;	
		}	
		.base-btn:hover {
    		background: #42A0FF;
		}				
		.menu-select {
			display: block;
			float: left;
			max-width: 18vw;
			margin-left: 20px;
			text-align: center;

			.el-cascader__label{
				margin-top: 9px;
			}

			.el-input__inner{
				border-color: #B6B6B6;
				background-color: white;
				border-radius: 2px;
				font-size: 14px;
				font-weight: 500;
				color: #222;
				line-height: 24px;
				margin-top: 9px;	
			}
	
			.el-input__icon{
				width: 40px;
				margin-top: 4px;
				color: #626874;
			}
		
			.el-input__suffix {
				&:before {
					content: '';
					position: absolute;
					left: 0;
					height: 32px;
					width: 1px;
					background-color: rgba(151, 151, 151, .35);
					margin-top: 7px;
				}
			}

			.el-icon-arrow-up {
				&:before {
					color: #a7a7a7;
					content: '\25B2';
				}
			}
		}	
	}
	.open-circle-status {
		height: 13px;
		width: 13px;
		background-color: rgb(78, 185, 7);
		border-radius: 50%;
		display: block;	
		float: left;	
		margin-top: 6px;
	}	
	.open-status {
		margin-left: 25px;
	}	
	.close-circle-status {
		height: 13px;
		width: 13px;
		background-color: #bbb;
		border-radius: 50%;
		display: block;	
		float: left;	
		margin-top: 6px;
	}	
	.close-status {
		margin-left: 25px;
	}	
	.page-bar {
		background: #ffffff;
		height: 48px;
		border-left: 1px solid #EEE;
		border-right: 1px solid #EEE;
		border-top: 1px solid #EEE;
    	//padding: px;
    	//margin: 5px 0px;
		.total-results {
			display: block;
			float: left;
			font-size: 14px;
			display: table-cell;
			vertical-align: middle;
			line-height: 24px;
			margin-top: 12px;
			margin-left: 20px;
			font-weight: 500;
			//padding: 0 5px;
			color: #626874;
		}
		.el-pagination {
			margin-top: 8px;	
			line-height: 24px;
			margin-right: 15px;
		}	
	}
	.search-no-item {
		background-color: #ffffff;
		width: 100%;
		height: 600px;
		border: 1px solid #EEE;
		margin-left: -1px;
		.nofound-icon {
			vertical-align: middle;
			text-align: center;
			width: 70px;
			height: 70px;
			display: table;
			margin: 152px auto;
		}
		.title-no-item {
			color: #222222;
			text-align: center;
			margin-top: -100px;
			font-size: 18px;
		}
		.vice-title-no-item {
			color: #626874;
			text-align: center;
			font-size: 14px;
		}
	}
	.el-cascader-menu {
		height: auto;
	}

	.account-add-dialog {
		.dialog-row {
			height: 80px;
			display: flex;
   			align-items: center;
			color: #222222;
  			font-size: 16px;

			.general-btn {
				margin-left: auto;
				color: #FFFFFF;
  				font-size: 16px;
				height: 40px;
				width: 92px;
				border: 1px solid #2E90F4;
				border-radius: 2px;
				background-color: #2E90F4;
			}

			.general-btn:hover {
				background: #42A0FF;
				cursor: pointer;	
			}	
		}

		.csv-hint {
			
			color: #515151;
			float:right;
		}

		.divider {
            height: 1px;
            width: 100%;
            border: 1px solid #EEEEEE;
        }

		.import-sample {
			float: left;
			height: 30px;
			text-decoration: underline;
		}
	}
	
	.account-edit-dialog {
		.content-text {
			margin-left:15px;
			color: #222222;
			font-size: 16px;
			height: 50px;
		}

		.button-row {
			margin-left:15px;
			display: block;
			float: left;
			height: 100px;
			
			.general-btn {
				height: 40px;
				width: 108px;
				border: 1px solid #2E90F4;
				border-radius: 2px;
				background-color: #FFFFFF;
				color: #2E90F4;
  				font-size: 16px;
			}

			.general-btn:hover {
				background: #c8E3FD;
				cursor: pointer;	
			}
		}
	}
</style>


// WEBPACK FOOTER //
// AccountTable.vue?5ebb0ab8